<template>
  <div class="cp-tabs_active-bar">
    <span ref="bar" :style="barStyle"></span>
  </div>
</template>

<script>
export default {
  name: 'CPTabBar',
  props: {
    tabs: Array
  },
  data() {
    return {
      barSize: 0
    }
  },
  computed: {
    barStyle() {
      const style = {}
      let tabSize = 0
      let offset = 0
      this.tabs.every((tab, index) => {
        const $el = this.$parent.$refs.tabs.filter(
          (e) => e.id.replace('tab-', '') === tab.paneName
        )[0]
        if (!$el) return false
        tabSize = $el.clientWidth
        if (!tab.active) {
          offset += tabSize
          return true
        } else {
          const tabStyle = window.getComputedStyle($el)
          if (index === 0) {
            tabSize -= parseFloat(tabStyle.paddingRight)
          }
          offset += tabSize / 2
          return false
        }
      })
      const transform = `translateX(${offset - this.barSize / 2}px)`
      style.transform = transform
      style.msTransform = transform
      style.webkitTransform = transform
      return style
    }
  },
  mounted() {
    this.barSize = this.$refs.bar.clientWidth
  }
}
</script>
